'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  display: flext;\n  align-items: center;\n  justify-content: center;\n'], ['\n  width: 100%;\n  height: 100%;\n  display: flext;\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: auto;\n  text-align: center;\n'], ['\n  margin: auto;\n  text-align: center;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: ', 'px !important;\n  color: ', ';\n'], ['\n  font-size: ', 'px !important;\n  color: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 20px;\n'], ['\n  width: 100%;\n  height: 20px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../../../libs/colors');

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _P = require('../../P/P');

var _P2 = _interopRequireDefault(_P);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject);

var Content = _styledComponents2.default.div(_templateObject2);

var StyledIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject3, function (_ref) {
  var small = _ref.small;
  return !!small ? 30 : 60;
}, _colors.darkGrey);

var Seperator = _styledComponents2.default.div(_templateObject4);

var NoFolders = function NoFolders(_ref2) {
  var small = _ref2.small;
  return _react2.default.createElement(Container, null, _react2.default.createElement(Content, null, _react2.default.createElement(StyledIcon, {
    icon: 'unknowfile1',
    small: small ? 1 : 0
  }), _react2.default.createElement(Seperator, null), _react2.default.createElement(_P2.default, {
    weight: 'medium',
    align: 'center'
  }, 'No Documents Found')));
};

NoFolders.propTypes = {
  small: _propTypes2.default.bool
};
exports.default = NoFolders;